<template>
    <div class="_caseTask">
        <CustomTaskForm
            :atShowAuditLog="onShowAuditLog"
            :update="updateForm"
            :form="form"
            :$v="$v"
            :formConfig="formConfig"
            :recordData="recordData"
            :groupIndex="groupIndex"
            :orderIndex="orderIndex"
            :taskCrud="true"
            :headerColor="headerColor"
            :isIframeMode="isIframeMode"
            :iframeModelId="iframeModelId"
        ></CustomTaskForm>

        <md-dialog :md-active.sync="auditLogDialog">
            <md-dialog-title>Audit Log</md-dialog-title>
            <md-dialog-content>
                <AuditLogDialog :list.sync="auditLogList" :filter.sync="auditLogFilter"></AuditLogDialog>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-theme-default" @click="auditLogDialog = false">Close</md-button>
            </md-dialog-actions>
        </md-dialog>
      
        <div class="md-layout-item md-size-100 _taskLayoutCard">
            <h3><span class="heading">Task Feed</span></h3>

          <div class="_commentBox" :class="{ active: showEditorFlag }">
            <div v-show="showEditorFlag">
              <div class="_commentBox__form">
                <md-field class="_tinyMceField">
                  <TinyMceEditor v-model="comment.body" theId="comment" :mentionArr="userListItems" @itemSelected="commentItemSelected" />
                  <div class="dynamicList-loading-spinner" v-show="promisePending">
                    <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                  </div>
                </md-field>
                <div class="md-space-between">
                  <md-card-actions md-alignment="left">
                    <md-button class="md-simple md-just-icon _attachFileBtn">
                      <i class="material-icons" v-on:click="onUpload()">attachment</i>
                    </md-button>
                    <span v-if="attachmentData == null">Browse or attach file here</span>
                    <!-- <div class="md-layout-item" v-if="attachmentData">
                        <div class="md-layout md-gutter md-alignment-center">
                        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" >
                            <div v-show="attachmentData.file.name" class="attchment-card">
                            <div class="attchment-container">{{ attachmentData.file.name }}
                                <div>{{ attachmentData.description }}</div> ({{ attachmentData.file.size | kb }} kb)
                                <div>{{ attachmentData.type }}</div>
                                <button type="button" class="attachment-button" title="Remove" @click="removeFile()" >x</button>
                            </div>
                            <md-checkbox
                                class="attachment-area__checkbox"
                                v-show="$Session && $Session.isInternalGroupMember"
                                v-model="isInternal"
                            >Internal</md-checkbox>
                            </div>
                        </div>
                        </div>
                    </div> -->
                  </md-card-actions>
                  <md-card-actions md-alignment="right">
                    <md-checkbox v-show="$Session && $Session.isInternalGroupMember" v-model="comment.internal">Internal</md-checkbox>
                    <md-button class="md-sm md-success" :disabled="comment.body==''" @click="sendComment()"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i> Submit</md-button>
                    <md-button class="md-sm md-danger" @click="closeEditor('comment')"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel</md-button>
                  </md-card-actions>
                </div>
              </div>
            </div>
            <div v-show="!showEditorFlag" @click="showEditor('comment')">
              Click to write your comment.
            </div>
            <div class="md-autocomplete-loading" v-if="isBusy">
              <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
            </div>
          </div>
          <!-- Upload Dialog -->
          <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
            <md-dialog-title>Attachment</md-dialog-title>
            <md-dialog-content>
              <CommentAttachmentsForm
                  :docTypes="docTypes"
                  :model="attachmentData"
                  @success="onUploadSuccess"
              />
            </md-dialog-content>
          </md-dialog>

          <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
            <span>{{ snackbarMsg }}</span>
          </md-snackbar>

            <TaskFeed :items="feedActive" :taskId="iframeModelId" :userListItems="userListItems" :task="recordData" />
        </div>

        <div class="md-layout-item md-size-100 _taskLayoutCard">
            <md-button 
                class="md-sm md-primary" 
                @click="loadNextFeedData" 
                title="Load More" v-if="feedHasMore()"
                style="margin: 0 0 7px 0;"
            >Load More</md-button>
        </div>

    </div>
</template>

<script>
    import TaskMixin from "@/pages/Tasks/Mixins/TaskMixin";
    import AuditLogDialog from "@/components/DynamicForm/AuditLogDialog";
    import TaskFeed from "@/components/TaskFeed";
    import { Tabs } from "@/components";
    import TinyMceEditor from "@/components/Editor/TinyMceEditor";
    import { Collapse } from "@/components";
    import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';   
    import Attachments from '@/components/DynamicForm/Attachments/Attachments';
    const AttachmentsMixin = {
        methods: {
            getDocTypes: Attachments.methods.getDocTypes,
        }
    }; 
    export default {
        name: "CaseTask",
        mixins: [TaskMixin, AttachmentsMixin],
        props: {
            isIframeMode: {
                type: Boolean,
                default: false,
                required: false,
            },
            iframeModelId: {
                type: String,
                default: '',
                required: false,
            },
        },
        components: {
            AuditLogDialog,
            TaskFeed,
            Tabs,
            TinyMceEditor,
            Collapse,
            CommentAttachmentsForm,
        },
        data() {
            return {
                activeModel: {},
                isUploadDialogOpen: false,
                docTypes: [],
                promisePending: false,
            };
        },
        async mounted() {
            this.docTypes = await this.getDocTypes();
        },
        methods: {
            /**
             * Show attachment upload form
             * @returns {Void}
             */
            onUpload() {
                this.isUploadDialogOpen = true;
            },
            /**
            * Attachment was successfully added or updated
            * Close dialog
            * @returns {Void}
            */
            onUploadSuccess(attachmentData) {
                this.isUploadDialogOpen = false;
                this.attachmentData = attachmentData;
                console.log("attachmentData ", attachmentData);
            },
            removeFile(){
                this.attachmentData = null;
            },    
        }
    };
</script>
